// En-tête et barre d'action mobile au défilement (maquette « 30 sept »), un seul écouteur
// `scroll` passif et un rAF par image au plus :
// - au-delà de 400 px l'en-tête se réduit (88 → 68 px, classe is-shrunk, layout/_header.scss) ;
// - sur une page qui a un sous-bandeau collant (`[data-anima-sousbandeau]`, fiches entreprise),
//   l'en-tête se masque quand on descend au-delà de 160 px et revient quand on remonte ;
// - la barre d'action mobile (`[data-anima-barre]`) monte quand on remonte au-delà de 600 px ;
// - la hauteur visible de l'en-tête est publiée dans `--anima-header-h` sur <html> : le
//   sous-bandeau et le rail des entreprises s'y calent ;
// - le bouton « retour en haut » remonte au-dessus de la barre légale quand elle paraît.

const SHRINK_FROM = 400 // px
const HIDE_FROM = 160 // px
const BAR_FROM = 600 // px
const DELTA = 2 // px, en dessous on ignore le sens du défilement

const init = () => {
  const header = document.getElementById('header')
  if (!header) {
    return
  }
  const root = document.documentElement
  const hideOnDown = document.querySelector('[data-anima-sousbandeau]') !== null
  const bar = document.querySelector('[data-anima-barre]')
  let lastY = window.scrollY
  let down = false
  let ticking = false

  // Écrire une propriété sur <html> recalcule le style de toute la page : seulement si elle change.
  let lastH = ''
  const publish = () => {
    const hidden = header.classList.contains('is-hidden')
    const h = `${hidden ? 0 : header.offsetHeight}px`
    if (h !== lastH) {
      lastH = h
      root.style.setProperty('--anima-header-h', h)
    }
  }

  let barOn = null
  const setBar = (on) => {
    if (!bar || on === barOn) {
      return
    }
    barOn = on
    bar.classList.toggle('is-on', on)
    root.classList.toggle('anima-barre-on', on)
    bar.setAttribute('aria-hidden', on ? 'false' : 'true')
    bar.querySelectorAll('a').forEach((a) => {
      a.tabIndex = on ? 0 : -1
    })
  }

  const update = () => {
    ticking = false
    const y = window.scrollY
    if (Math.abs(y - lastY) > DELTA) {
      down = y > lastY
      lastY = y
    }
    header.classList.toggle('is-shrunk', y > SHRINK_FROM)
    if (hideOnDown) {
      header.classList.toggle('is-hidden', y > HIDE_FROM && down && !root.classList.contains('anima-modale-open'))
    }
    setBar(!down && y > BAR_FROM && !root.classList.contains('anima-modale-open'))
    publish()
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true
      requestAnimationFrame(update)
    }
  }, {
    passive: true
  })
  // La hauteur change pendant la réduction (transition 250 ms) et au redimensionnement.
  if ('ResizeObserver' in window) {
    new ResizeObserver(publish).observe(header)
  }
  header.addEventListener('transitionend', publish)
  update()

  // Retour en haut : il reste au-dessus de la barre légale du pied quand elle est à l'écran
  // (maquette « 30 sept »), au lieu de recouvrir ses liens.
  const legal = document.querySelector('.anima-pied-legal')
  if (legal && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      root.classList.toggle('anima-legal-on', entry.isIntersecting)
      root.style.setProperty('--anima-legal-h', `${legal.offsetHeight}px`)
    }).observe(legal)
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
